import { render, staticRenderFns } from "./ChooseExpertise.vue?vue&type=template&id=4523d108"
import script from "./ChooseExpertise.vue?vue&type=script&lang=js"
export * from "./ChooseExpertise.vue?vue&type=script&lang=js"
import style0 from "./ChooseExpertise.vue?vue&type=style&index=0&id=4523d108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports